import LottieImport, { LottieRefCurrentProps } from 'lottie-light-react';

const Lottie = (
  'default' in LottieImport ? LottieImport.default : LottieImport
) as typeof LottieImport;

export type { LottieRefCurrentProps };
export default Lottie;
